// AdminWidgetsSpec.js — 관리자 위젯별 Icon + label + render 정의 (2026-06-06)
//
// 카테고리별 분리:
//   - AdminWidgetsSpec.staff.js
//   - AdminWidgetsSpec.sales.js
//   - AdminWidgetsSpec.finance.js
//   - AdminWidgetsSpec.system.js
//   - AdminWidgetsSpec.integrated.js (2026-06-09 추가, 통합 메뉴 위젯 — 동적 spec)

import { STAFF_SPECS } from './AdminWidgetsSpec.staff';
import { SALES_SPECS } from './AdminWidgetsSpec.sales';
import { FINANCE_SPECS } from './AdminWidgetsSpec.finance';
import { SYSTEM_SPECS } from './AdminWidgetsSpec.system';
import { buildIntegratedSpec, isIntegratedWidgetCode } from './AdminWidgetsSpec.integrated';
import { buildCompanyWidgetSpec, isCompanyWidgetCode } from './AdminWidgetsSpec.company-dynamic';

export const ADMIN_WIDGET_SPECS = {
  ...STAFF_SPECS,
  ...SALES_SPECS,
  ...FINANCE_SPECS,
  ...SYSTEM_SPECS,
};

// 위젯 코드 → spec 조회 (정적 ADMIN_WIDGET_SPECS 우선, 없으면 통합 위젯 prefix 매칭으로 동적 생성).
//   data 인자는 통합 위젯 라벨에 menuName 반영용. data 없이 호출하면 기본 "통합 메뉴 (통합)" 사용.
//   visibleCodes 필터에는 hasAdminSpec(code) 사용 — render data 가 없어도 매칭만 확인.
export function getAdminWidgetSpec(code, data) {
  const stat = ADMIN_WIDGET_SPECS[code];
  if (stat) return stat;
  // 목록에 없는 회사의 회사별 위젯(2026-09-10) — 코드에서 회사를 되읽어 같은 함수로 만든다.
  //   정적 조회가 먼저라 기존 3사 동작은 그대로다.
  const company = buildCompanyWidgetSpec(code);
  if (company) return company;
  return buildIntegratedSpec(code, data);
}

export function hasAdminSpec(code) {
  if (ADMIN_WIDGET_SPECS[code]) return true;
  if (isCompanyWidgetCode(code)) return true;
  return isIntegratedWidgetCode(code);
}

// 공통 포매터 export (각 spec 파일에서도 사용)
export const fmt = (n) => Number(n || 0).toLocaleString();
export const won = (n) => `${fmt(n)}원`;
